var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"include-logo-checkbox"},[_c('b-form-checkbox',{attrs:{"checked":_vm.userStore.useLogo,"disabled":_vm.disable,"data-testid":"include_logo_checkbox"},on:{"input":_vm.updateUseLogo}},[_c('span',[_vm._v("Add my logo to appraisal reports")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }